import { Typography } from 'antd';
import ChatSessionTickets from 'components/ai-agent-center/ChatSessionTickets';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import dayjs from 'dayjs';
import { aiAgentCenterMessages, omniChatMessages } from 'messages';
import ChatContactInfo from './ChatContactInfo';
import Avatar from 'components/common/avatar/Avatar';
import { ChatSessionDto } from 'types';

type HistoryChatDetailsProps = {};

const AgentSupported = ({ item }: { item: ChatSessionDto }) => {
  return (
    <div className='mb-5 border-b px-5 pb-6'>
      <Typography.Text className='font-semibold'>{aiAgentCenterMessages.agentSupported}</Typography.Text>
      <div className='flex gap-4'>
        <div className='mt-5 flex w-full items-center gap-4'>
          <Avatar key={item.assigner?.userId} size={48} src={item?.assigner?.avatar} name={item?.assigner?.fullName} />
          <div className='flex flex-col gap-1'>
            <Typography.Text>{item?.assigner?.fullName}</Typography.Text>
            <Typography.Text className='text-sm text-colorTextPlaceholder'>Ext. {item.extensionId}</Typography.Text>
          </div>
        </div>
      </div>
    </div>
  );
};

const HistoryChatDetails: React.FC<HistoryChatDetailsProps> = ({}) => {
  const { chatHistory } = useOmniHistoriesLeadManageContext();

  return (
    <div className='flex h-full flex-col pb-6'>
      <div className='flex h-16 shrink-0 items-center gap-2 border-b px-4'>
        <Typography.Text className='text-lg font-semibold'>{omniChatMessages.chatDetails}</Typography.Text>
      </div>
      <div className='h-[calc(100vh-268px)] overflow-y-auto'>
        <ChatContactInfo />
        {chatHistory && <AgentSupported item={chatHistory} />}
        <div className='border-b pb-6'>
          <div className='flex flex-col px-5'>
            <Typography.Text className='font-semibold'>{omniChatMessages.processingTime}</Typography.Text>
            <Typography.Text className='mt-4'>
              Từ {dayjs(chatHistory?.processingAt).format('HH:mm')}
              {chatHistory?.completedAt ? ` đến ${dayjs(chatHistory?.completedAt).format('HH:mm')}` : ''}
            </Typography.Text>
          </div>
        </div>
        <ChatSessionTickets chatSessionId={chatHistory?.chatSessionId} />
      </div>
    </div>
  );
};

export default HistoryChatDetails;
